import type { OgsmStatus } from '@/types/api'

/** Left border of a band or row, so status reads across the whole line. */
export const STATUS_BORDER: Record<OgsmStatus, string> = {
  ON_TRACK: 'border-l-status-on-track-ring/60',
  ACHIEVED: 'border-l-status-achieved/60',
  AT_RISK: 'border-l-status-at-risk-ring/60',
  OFF_TRACK: 'border-l-status-off-track-ring/60',
  NOT_STARTED: 'border-l-primary/20',
  ON_HOLD: 'border-l-status-not-started-ring/60',
}
